import { useEffect, useState } from "react";
import { Download } from "lucide-react";

export default function InstallAppButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      setDeferredPrompt(null);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (!deferredPrompt || installed) return null;

  const install = async () => {
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
  };

  return (
    <button
      onClick={install}
      data-testid="nav-install-button"
      className="flex items-center gap-2 rounded-full border border-neon-lime/50 bg-neon-lime/10 px-4 py-2 font-mono text-xs font-bold uppercase tracking-[0.2em] text-neon-lime transition-all hover:-translate-y-0.5 hover:bg-neon-lime/20 hover:shadow-[0_0_20px_rgba(34,197,94,0.35)]"
    >
      <Download className="h-3.5 w-3.5" />
      Get the App
    </button>
  );
}
